import { useEffect, useState } from "react";

import { fetchDashboardData } from "services/dashboard.services";
import { selectUserType } from "store/auth/selectors";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { dashboardConfig } from "./const"; // Import configuration

import styles from "./styles.module.scss";

const DashboardMainPage = () => {
  const { t } = useTranslation("global");
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.currentUser);
  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState(null);

  const userType = useSelector(selectUserType); // Default to "seeker"
  const config = user?.master_seeker ? dashboardConfig["master_seeker"] : dashboardConfig[userType];

  // Helper function to get nested property value
  const getNestedValue = (obj, path) => {
    if (!obj || !path) return 0;
    return path.split('.').reduce((current, key) => {
      return current?.[key] !== undefined ? current[key] : 0;
    }, obj);
  };

  useEffect(() => {
    const getDashboardData = async () => {
      try {
        const data = await fetchDashboardData(token);
        setDashboardData(data);
      } catch (err) {
        setError(err.message);
      }
    };

    getDashboardData();
  }, [token]);

  return (
    <section className={styles.main}>
      <div className={styles.welcome}>
        <p>
          <span>{t("dashboard.welcome")}</span> <span>{user?.first_name}</span>
        </p>
      </div>
      <div className={styles.summary}>
        {config?.summaryBlocks?.map((block, index) => (
          <div key={index} className={styles.summaryBlock}>
            <span>{getNestedValue(dashboardData, block.valueKey)}</span>
            <p>{t(`dashboard.${block.key}`)}</p>
          </div>
        ))}
      </div>
      <div className={styles.contact}>
        <p
          dangerouslySetInnerHTML={{
            __html: t(`dashboard.${config?.contactTextKey}`),
          }}
        ></p>
      </div>
      {!user?.master_seeker && !user?.trainee && (
        <div className={styles.bookingSteps}>
          {config?.steps.map((step, index) => (
            <div key={index} className={styles.card}>
              <step.SvgIcon
                className={styles.icon}
                viewBox="0 0 100 140" // Try 64x64 to see if it's still cut off
                preserveAspectRatio="xMidYMid meet"
              />
              <h4>
                {index + 1}. {t(`manual.${userType}.${step.titleKey}`)}
              </h4>
              <p>{t(`manual.${userType}.${step.textKey}`)}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default DashboardMainPage;